<template>
<!-- FINAL ICARE -->
  <form @submit.prevent>
     <CModal
        :title.sync="title" 
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow v-if="!loading">
          <CCol>
            <label > Choose Relation </label>
            <b-form-select v-model="form.target" :options="options_relation"></b-form-select>
            <label class="mt-3" > Choose People </label>
            <model-select v-model="form.id" :options="options" placeholder="Select People"></model-select>
          </CCol> 
        </CRow>
        <CRow v-else class="center"><b-spinner variant="primary" label="Spinning"><br></b-spinner></CRow>       

        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="submit_relation(p_id)"  variant="outline" color="info">Submit</CButton>
        <!-- <pre>{{ $data | json }}</pre> -->
        </template>
    </CModal>
  </form>
</template>

<script>
import EventBus from '@/eventBus';
import { ModelSelect } from 'vue-search-select'
import people from '@/services/people';

export default {
name: 'relationmodal',
components: {
      ModelSelect
    },
  data () {
    return {
    show: false,
    title: 'Default Title',
    mode: '',
    form:{
      target:'',
      id:'',
    },
    p_id:'',
    loading: false,
    // options_relation:[
    //   {text: 'son', value:'son'},
    //   {text: 'daughter', value:'daughter'},
    //   {text: 'dad', value:'dad'},
    //   {text: 'mom', value:'mom'},
    //   {text: 'uncle', value:'uncle'},
    //   {text: 'aunt', value:'aunt'},
    //   {text: 'nephew', value:'nephew'},
    //   {text: 'niece', value:'niece'},
    //   {text: 'grandpa', value:'grandpa'},
    //   {text: 'grandma', value:'grandma'},
    //   {text: 'grandson', value:'grandson'},
    //   {text: 'granddaughter', value:'granddaughter'},
    //   {text: 'etc', value:'etc'},
    // ],
    options_relation:[],
    options:[],
    }
  },
  
  mounted (){
     

     
   },
   
  created () {
    var self = this; 
    EventBus.$on('OPEN_MODAL_RELATION', (params) => {
      if(params.data){
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.p_id = params.data;

        this.loading = true
        this.options = []
        this.options_relation = []

        people.get_relation_list()
        .then(res => {
          for (let i=0; i <= res.data.length-1; i++){
            this.options_relation.push({
              text: res.data[i].name_relation,
              value:res.data[i].id_relation
            })
            //this.loading = false
          }
        }).catch((er) =>{
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
        
        people.getPeople()
        .then(res => {
          for (let i=0; i <= res.data.length-1; i++){
            this.options.push({
              text: res.data[i].firstname + " " + res.data[i].lastname + " - " +  res.data[i].status,
              value:res.data[i].uuid
            })
            this.loading = false
          }
        }).catch((er) =>{
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })

      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
      }
    });

  },
  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
  
    submit_relation(id){
        this.show = false;
          people.assign_relation(id, this.form)
          .then(res => {
            EventBus.$emit('PAGE_UPDATE', true)
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
      },
   
     
   
  }
}
</script>

<style>

</style>